import { useMutation } from '@apollo/client/react';
import { CreateProjectDialogDocument } from './mutation.gql';
export const useCreateProject = () => {
    const [mutate, state] = useMutation(CreateProjectDialogDocument);
    const createProject = (input) => mutate({
        variables: { input },
        update: (cache, { data }) => {
            const { createFileSystemProject } = data || {};
            if (createFileSystemProject) {
                cache.modify({
                    fields: {
                        fileSystemProjects(existing = []) {
                            return [...existing, createFileSystemProject];
                        },
                    },
                });
            }
        },
    });
    return [createProject, state];
};
